export default __webpack_public_path__ + "static/media/arena_17.c60d9fc7.jpeg";